import { render } from "./TrainingList.vue?vue&type=template&id=8fe8cfb6"
import script from "./TrainingList.vue?vue&type=script&lang=js"
export * from "./TrainingList.vue?vue&type=script&lang=js"

import "./TrainingList.vue?vue&type=style&index=0&id=8fe8cfb6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__